import type { Editor } from "@tiptap/react";
import { useState } from "react";

import { PickerBody } from "./PickerBody";
import { ProgressOverlay } from "./ProgressOverlay";
import { SearchField } from "./SearchField";
import type { AddToLocalInlineAttachments, EditorRange } from "./types";
import { useGiphySearch } from "./useGiphySearch";
import { useGiphyUpload } from "./useGiphyUpload";

interface PickerContentProps {
  addToLocalInlineAttachments: AddToLocalInlineAttachments;
  editor: Editor;
  onClose: () => void;
  range: EditorRange;
}

export const PickerContent = ({
  editor,
  range,
  addToLocalInlineAttachments,
  onClose,
}: PickerContentProps) => {
  const [query, setQuery] = useState("");
  const { gifs, fetchNextPage, hasNextPage, isInitialLoading } =
    useGiphySearch(query);
  const { addGif, isProcessing, progress } = useGiphyUpload({
    editor,
    range,
    addToLocalInlineAttachments,
    onComplete: onClose,
  });

  return (
    <div
      className="relative w-[408px] max-w-[calc(100vw-3rem)]"
      data-testid="giphy-picker"
    >
      <div
        className={isProcessing ? "pointer-events-none opacity-50" : undefined}
        aria-hidden={isProcessing}
      >
        <SearchField onChange={setQuery} />
        <div className="h-[360px] overflow-hidden">
          <PickerBody
            gifs={gifs}
            isInitialLoading={isInitialLoading}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isDisabled={isProcessing}
            onSelect={addGif}
          />
        </div>
      </div>
      {isProcessing && <ProgressOverlay progress={progress} />}
    </div>
  );
};
